/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type { NotificationLogs as NotificationLogsType } from '@jira/spa-apps__servicedesk-notification-logs/src/NotificationLogs.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyNotificationLogs: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof NotificationLogsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-notification-logs", jiraSpaEntry: "async-servicedesk-notification-logs" */ '@jira/spa-apps__servicedesk-notification-logs/src/ServicedeskNotificationLogs.tsx'
		),
	),
);

export const NotificationLogs = (): React.JSX.Element => (
	<LazyPage
		Page={LazyNotificationLogs}
		pageId="spa-apps/servicedesk/notification-logs"
		shouldShowSpinner
	/>
);
